'use client';
// src/components/GoogleAnalytics.tsx
import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const GA_ID = 'G-JB7P1SPY3H';

// Paths to exclude from tracking (separate apps/services, or contain a
// secret token in the URL — /delivery/{token} без кукі/логіну, токен=пароль;
// раніше сюди мала потрапляти /redeem, але /delivery/redeem не збігався з
// цим префіксом взагалі — page_location з повним URL і токеном щоразу йшов у GA).
const EXCLUDED_PREFIXES = ['/delivery'];

function gtag(...args: unknown[]) {
  if (typeof window !== 'undefined' && typeof (window as any).gtag === 'function') {
    (window as any).gtag(...args);
  }
}

export function GoogleAnalytics() {
  const pathname = usePathname();

  useEffect(() => {
    if (EXCLUDED_PREFIXES.some(prefix => pathname.startsWith(prefix))) return;

    gtag('event', 'page_view', {
      page_path: pathname,
      page_location: typeof window !== 'undefined' ? window.location.href : '',
      page_title: typeof document !== 'undefined' ? document.title : '',
      send_to: GA_ID,
    });
  }, [pathname]);

  return null;
}
